import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'
import kubun from 'config/kubun.json'

export const SaimuMeimokuKbn = props => {
  const options = kubun.saimu_meimoku_kbn

  return <Dropdown.Standard options={options} {...props} />
}
